import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'
import { tideCashBackAmount } from './business-banking-strings'

const defaultStrings = {
  cashback: `${tideCashBackAmount} cashback`,
  claimOffer: 'Claim offer',
  crunchServiceCTA: 'Claim offer',
  crunchServiceDescription:
    'Get fully featured bookkeeping software for your business completely free. <strong>Free forever.</strong> No hidden charges. Add a real accountant at any time.',
  crunchServiceOffer: 'FREE',
  crunchServiceTitle: 'Crunch Free Accounting',
  directorsServiceAddress: 'Full Privacy Service',
  directorsServiceAddressDescription:
    "Protect your privacy — our Director's Service lets you list our address on Companies House, not your home.",
  freePostageCredit: 'Free postage credit',
  phone: 'WhatsApp for Business Number',
  phoneDescription: 'Get a dedicated business phone number from Hoxton Mix.',
  phoneShort: 'W4B',
  phoneSummary:
    'Connect with your customers directly, immediately and more effectively with our WhatsApp for Business number service.',
  primeLondonNumber: 'Prime London number',
  scanLite: 'Virtual Office + HaiRo™',
  scanLiteDescription:
    '<span class="d-sm-inline d-block">We scan and email all your post to</span> you within one business day of receiving it.',
  scanLiteSummary: 'Mail Handling\nScanned and Emailed',
  scanPro: 'Mail Forwarding',
  scanProDescription:
    'We scan, email, and forward the hard copies to you by post within one business day.',
  scanProSummary:
    'As well as being scanned, your mail will be forwarded within one business day to an address of your choice.',
  tideBusinessBanking: 'Tide Business Banking',
  tideBusinessBankingDescription: `Get a free bank account with <strong>${tideCashBackAmount} cashback</strong>.*<br/>T&Cs apply.`,
  virtualOfficePhone: 'WhatsApp for Business Number',
  workFromAnywhere: 'Work from anywhere',
}

export const planSummaryStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
